module.exports = __webpack_public_path__ + "img/tc.30b3889e.png";